import { createSlice } from "@reduxjs/toolkit";

import { IBadRequestStore } from "./types";

const initialState: IBadRequestStore = {
  isInternetError: false,
  isRecconectPopup: false,
  isReloadPopup: false,
  errorText: "",
};

export const badRequestsSlice = createSlice({
  name: "badRequestsSlice",
  initialState,
  reducers: {
    // internet
    setInternetError: state => {
      state.isInternetError = true;
    },
    stopInternetError: state => {
      state.isInternetError = false;
    },
    // reload popup
    setReloadPopup: state => {
      state.isReloadPopup = true;
    },
    hideReloadPopup: state => {
      state.isReloadPopup = false;
    },
    // reconnect

    setRequestReconnect: state => {
      state.isRecconectPopup = true;
    },
    stopRequestReconnect: state => {
      state.isRecconectPopup = false;
    },
    // error text
    setErrorText: (state, action) => {
      state.errorText = action.payload || "Something went wrong";
    },
    clearErrorText: state => {
      state.errorText = "";
    },
  },
});

export const {
  clearErrorText,
  setErrorText,
  stopRequestReconnect,
  setRequestReconnect,
  hideReloadPopup,
  setReloadPopup,
  stopInternetError,
  setInternetError,
} = badRequestsSlice.actions;

export default badRequestsSlice.reducer;
